import Api from "./Api";

export default {

    createFolder(payload) {
        return Api().post('/file-folder', payload);
    },
    editFolder(payload) {
        // return Api().put(`/file-rename/${payload.company_id}/${payload.id}`, payload);
        return Api().put(`/file-rename`, payload);
    },
    deleteFolder(payload) {
        return Api().delete(`/file/${payload.companyId}/${payload.id}`);
    },

};